import { render, staticRenderFns } from "./FooterContent.vue?vue&type=template&id=847390a8&scoped=true"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"
import style0 from "./FooterContent.vue?vue&type=style&index=0&id=847390a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "847390a8",
  null
  
)

export default component.exports